export function getImpliedConfirmedNetValue({
  originalNet,
  originalGross,
  confirmedGross,
}: {
  originalNet?: number | null;
  originalGross?: number | null;
  confirmedGross?: number | null;
}): number | null {
  if (originalNet == null || originalGross == null || originalGross === 0 || confirmedGross == null) {
    return null;
  }

  return parseFloat(((confirmedGross / originalGross) * originalNet).toFixed(2));
}
